import { motion } from "framer-motion";
import { Star, Users } from "lucide-react";
import { getAllReviews, getReviewStats } from "@/data/reviews";

export const SocialProofBadge = () => {
  const allReviews = getAllReviews();
  const { averageRating, totalReviews } = getReviewStats(allReviews);
  
  // Customer count - updated to 2,500+ for stronger social proof
  const customerCount = 2547;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.6 }}
      className="flex flex-wrap items-center justify-center gap-4 md:gap-6 py-4 md:py-6"
    >
      {/* Customer Counter */}
      <div className="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-background/80 backdrop-blur-sm rounded-full border border-border/50">
        <Users className="h-3.5 md:h-4 w-3.5 md:w-4 text-primary" />
        <span className="text-xs md:text-sm font-medium">
          <span className="text-primary font-bold">{customerCount.toLocaleString()}+</span> happy customers
        </span>
      </div>

      {/* Rating Badge */}
      <div className="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-background/80 backdrop-blur-sm rounded-full border border-border/50">
        <div className="flex items-center gap-0.5">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star
              key={star}
              className={`h-3 md:h-4 w-3 md:w-4 ${
                star <= Math.round(averageRating)
                  ? "fill-yellow-400 text-yellow-400"
                  : "text-gray-300"
              }`}
            />
          ))}
        </div>
        <span className="text-xs md:text-sm font-medium">
          <span className="font-bold">{averageRating}</span>/5 ({totalReviews} verified reviews)
        </span>
      </div>
    </motion.div>
  );
};
